import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M23.89 3.444 3.677 23 1.89 21.272 22.104 1.716l1.786 1.728Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.89 3.444 22.104 23l1.786-1.728L3.677 1.716 1.89 3.444Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }